/**************************************************
 * Nombre:       Tarjeta_Asesor
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Avatar, Grid, Typography} from "@mui/material";
import {WhatsApp} from "@mui/icons-material";
import {iniciarCharWass} from "../../Utilidades/iniciarCharWass";

const Tarjeta_Asesor = ({item}) => {

    return (
        <Grid
            onClick={() => iniciarCharWass(item.numero)}
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            size={12}
            sx={{
                cursor: 'pointer', backgroundColor: 'rgba(217,217,217,0.38)', borderRadius: 2, p: 1,
                '&:hover': {
                    boxShadow: 3
                }
            }}

        >

            <Grid item container size={3} sx={{justifyContent: 'flex-start'}}>
                <Avatar src={item.img} sx={{border: 3, borderColor: '#25D366', height: 46, width: 46}}/>
            </Grid>

            <Grid item container size={8} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                >

                    <Grid item container size={12} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontWeight: 600}}> {item.nombre}</Typography>
                    </Grid>

                    <Grid item container size={12} sx={{justifyContent: 'flex-start', marginTop: -0.5}}>
                        <Typography sx={{fontWeight: 600, color: '#22bd59', fontSize: 12}}>En linea</Typography>
                    </Grid>

                </Grid>

            </Grid>

            <Grid item container size={1} sx={{justifyContent: 'flex-end'}}>
                <WhatsApp sx={{fill: '#25D366'}}/>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Asesor